import { theme } from '@theme';
import { FC, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useCheckDevice } from '../../../../hooks/UseCheckDevice';
import { Icon } from '../../../style';
type SearchProps = {
  search: string;
  setSearch: (text: string) => void;
  type?: 'text' | 'number' | 'email';
  placeholder: string;
  cssClass?: string;
};

const Search: FC<SearchProps> = (props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { isMobileDevice } = useCheckDevice();

  const reset = (): void => props.setSearch('');
  const handleChange = (event: any): void => {
    props.setSearch(event.target.value);
  };

  useEffect(() => {
    if (!isMobileDevice) {
      inputRef?.current?.focus();
    }
  }, [isMobileDevice]);

  return (
    <Wrapper data-testid='search' className='unflex exclude-hover'>
      <InputBackground className='unflex'>
        <Icon type='loupe' size={20} data-testid='loupe' additionalClassName='exclude-hover' />
        <input
          type={props.type || 'text'}
          placeholder={props.placeholder}
          value={props.search}
          onChange={handleChange}
          ref={inputRef}
          className={`${props.cssClass || ''}`}
          data-testid='search-input'
        />
        {props.search && (
          <Icon type='x' size={theme.typography.fontSize14} onClick={reset} data-testid='x' />
        )}
      </InputBackground>
    </Wrapper>
  );
};

export default Search;

const Wrapper = styled.div`
  background-color: ${(props) => props.theme.palette.gray};
  padding: 7px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
`;

const InputBackground = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0;
  margin: 0;
  background-color: ${(props) => props.theme.palette.white};
  border-bottom: 1px solid ${(props) => props.theme.palette.gray};
  border-radius: 3px;
  & > input {
    width: 100%;
    border: none;
    height: 30px;
    background-color: ${(props) => props.theme.palette.transparent};
    outline: none;
    font-weight: ${(props) => props.theme.typography.fontWeights.normal};
    font-size: ${(props) => props.theme.typography.fontSize14}px;
    color: ${(props) => props.theme.palette.wetAsphalt};
  }
  & > input::placeholder {
    color: ${(props) => props.theme.palette.dusty};
  }
  & > span {
    align-self: center;
    margin-left: 10px;
    margin-right: 5px;
    color: ${(props) => props.theme.palette.dusty};
  }
`;
